<template>
    <div>
        <sweet-modal ref="chartReplaceModal" :modal-theme="$vuetify.theme.dark === true ? 'dark' : 'light'" :overlay-theme="$vuetify.theme.dark === true ? 'light' : 'dark'" blocking @close="onClose">
          
            <h4 name="descriptionChart" class="mb-6">Replace the chart by selecting from the list below</h4>
            <v-tabs v-model="tab"
                    class="mt-3"
                    background-color="transparent"
                    grow>
                <v-tab v-for="item in items"
                       :key="item">
                    {{ item }}
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" class="text-left">
                <v-tab-item v-for="item in items"
                            :key="item">

                    <v-progress-linear indeterminate
                                       v-if="isBusy"
                                       color="primary"></v-progress-linear>

                    <div v-if="item === 'My Charts'">

                        <div v-if="myChartTotalPages === 0" class="w-100 text-center text-subtitle-1 ma-3">
                            No charts found
                        </div>

                        <v-text-field v-model="myChartSearchText"
                                      append-icon="mdi-magnify"
                                      label="Search"
                                      single-line
                                      class="ma-6"
                                      hide-details></v-text-field>

                        <v-list two-line>
                            <template v-for="(chart, index) in myCharts">
                                <v-list-item :key="chart.id">
                                    <template v-slot:default="{  }">
                                        <v-list-item-content>

                                            <v-list-item-title v-text="chart.title"></v-list-item-title>

                                            <v-list-item-subtitle>
                                                <v-chip class="ma-2 text-right" label v-if="chart.type === 'LINE'"
                                                        color="default">
                                                    <v-icon left>
                                                        mdi-chart-line
                                                    </v-icon> {{chart.type}}
                                                </v-chip>

                                                <v-chip class="ma-2 text-right" label v-if="chart.type === 'WORDCLOUD'"
                                                        color="default">
                                                    <v-icon left>
                                                        mdi-alpha-w-box
                                                    </v-icon>{{chart.type}}
                                                </v-chip>

                                                <v-chip class="ma-2 text-right" label v-if="chart.type === 'PIE'"
                                                        color="default">
                                                    <v-icon left>
                                                        mdi-chart-arc
                                                    </v-icon>{{chart.type}}
                                                </v-chip>

                                                <v-chip class="ma-2 text-right" label v-if="chart.type === 'TABLE'"
                                                        color="default">
                                                    <v-icon left>
                                                        mdi-table
                                                    </v-icon> {{chart.type}}
                                                </v-chip>
                                            </v-list-item-subtitle>

                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-btn depressed @click="updateUserChart(chart.id)">
                                                Select
                                            </v-btn>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>

                                <v-divider v-if="index < myCharts.length - 1"
                                           :key="index"></v-divider>
                            </template>
                        </v-list>

                        <div class="text-center pb-3" v-if="myChartTotalPages > 0">
                            <v-pagination v-model="myChartPageNo"
                                          :length="myChartTotalPages"
                                          circle></v-pagination>
                        </div>

                    </div>

                    <div v-if="item === 'Template Charts'">

                        <div v-if="templateChartTotalPages === 0" class="w-100 text-center text-subtitle-1 ma-3">
                            No charts found
                        </div>

                        <v-text-field v-model="templateChartSearchText"
                                      append-icon="mdi-magnify"
                                      label="Search"
                                      single-line
                                      class="ma-6"
                                      hide-details></v-text-field>

                        <v-list two-line>
                            <template v-for="(chart, index) in templateCharts">
                                <v-list-item :key="chart.id">
                                    <template v-slot:default="{  }">
                                        <v-list-item-content>
                                            <v-list-item-title v-text="chart.title"></v-list-item-title>

                                            <v-list-item-subtitle>
                                                <v-chip class="ma-2 text-right" label v-if="chart.type === 'LINE'"
                                                        color="default">
                                                    <v-icon left>
                                                        mdi-chart-line
                                                    </v-icon> {{chart.type}}
                                                </v-chip>

                                                <v-chip class="ma-2 text-right" label v-if="chart.type === 'WORDCLOUD'"
                                                        color="default">
                                                    <v-icon left>
                                                        mdi-alpha-w-box
                                                    </v-icon>{{chart.type}}
                                                </v-chip>

                                                <v-chip class="ma-2 text-right" label v-if="chart.type === 'PIE'"
                                                        color="default">
                                                    <v-icon left>
                                                        mdi-chart-arc
                                                    </v-icon>{{chart.type}}
                                                </v-chip>

                                                <v-chip class="ma-2 text-right" label v-if="chart.type === 'TABLE'"
                                                        color="default">
                                                    <v-icon left>
                                                        mdi-table
                                                    </v-icon> {{chart.type}}
                                                </v-chip>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-btn depressed @click="updateUserChart(chart.id)">
                                                Select
                                            </v-btn>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>

                                <v-divider v-if="index < templateCharts.length - 1"
                                           :key="index"></v-divider>
                            </template>
                        </v-list>

                        <div class="text-center pb-3" v-if="templateChartTotalPages > 0">
                            <v-pagination v-model="templateChartPageNo"
                                          :length="templateChartTotalPages"
                                          circle></v-pagination>
                        </div>
                    </div>
                </v-tab-item>
            </v-tabs-items>

        </sweet-modal>
    </div>
</template>

<script>
    import ChartService from "../../services/chartService"
    import ReportLayoutService from "../../services/reportLayoutService"
    export default {
        props: {
            reportLayoutId: {
                default: "",
                type: String
            },
            isVisible: {
                default: false,
                type: Boolean
            },
            isReportBuilder: {
                default: false,
                type: Boolean
            }
        },
        watch: {
            deep: true,
            immediate: true,
            isVisible() {
                if (this.isVisible) {
                    this.$refs.chartReplaceModal.open();
                }
                else {
                    this.$refs.chartReplaceModal.close();
                }
            },
            //my charts
            myChartPageSize: function () {
                this.getMyCharts();
            },
            myChartPageNo: function () {
                this.getMyCharts();
            },
            myChartSearchText: function () {
                let self = this;
                clearTimeout(this.myChartSearchTimer);
                this.myChartSearchTimer = setTimeout(function () {
                    self.getMyCharts();
                }, 1000);
            },
            //template chart
            templateChartPageSize: function () {
                this.getTemplateCharts();
            },
            templateChartPageNo: function () {
                this.getTemplateCharts();
            },
            templateChartSearchText: function () {
                let self = this;
                clearTimeout(this.templateChartSearchTimer);
                this.templateChartSearchTimer = setTimeout(function () {
                    self.getTemplateCharts();
                }, 1000);
            },
        },
        data: function () {
            return {
                accessToken: "",
                myCharts: [],
                templateCharts: [],
                tab: null,
                items: [
                    'My Charts', 'Template Charts',
                ],
                isBusy: false,
                //My Charts Search
                myChartSearchText: "",
                myChartPageNo: 1,
                myChartPageSize: 5,
                myChartTotalItems: 0,
                myChartSearchTimer: null,
                //Template Charts Search
                templateChartSearchText: "",
                templateChartPageNo: 1,
                templateChartPageSize: 5,
                templateChartTotalItems: 0,
                templateChartSearchTimer: null,
            }
        },
        created() {
            this.setup();

            if (this.isReportBuilder) {
                this.items = [
                   'Template Charts',
                ];
            }
        },
        computed: {
            myChartTotalPages() {
                return Math.ceil(this.myChartTotalItems / this.myChartPageSize);
            },
            templateChartTotalPages() {
                return Math.ceil(this.templateChartTotalItems / this.templateChartPageSize);
            }
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();
                await this.getMyCharts();
                await this.getTemplateCharts();
            },
            async updateUserChart(chartId) {
                let result = null;
                if (!this.isReportBuilder) {
                    result = await ReportLayoutService.addUserReportLayoutChart(this.reportLayoutId, chartId, this.accessToken);
                }
                else {
                    result = await ReportLayoutService.addReportLayoutChart(this.reportLayoutId, chartId, this.accessToken);
                }

                if (result) {
                    this.$emit('replaced')
                }
            },
            onClose() {
                this.$emit('close')
            },
            async getMyCharts() {
                this.isBusy = true;

                let myChartResult = await ChartService.searchMyCharts(this.myChartSearchText, this.myChartPageNo, this.myChartPageSize, this.accessToken);

                this.myChartTotalItems = myChartResult.count;
                this.myCharts = myChartResult.data;

                this.isBusy = false;
            },
            async getTemplateCharts() {
                this.isBusy = true;

                let templateChartResult = await ChartService.searchTemplateCharts(this.templateChartSearchText, this.templateChartPageNo, this.templateChartPageSize, this.accessToken);

                this.templateChartTotalItems = templateChartResult.count;
                this.templateCharts = templateChartResult.data;

                this.isBusy = false;
            }

        }
    };
</script>
